/**
 * The purpose of this file is to regroup the other modules to bring about the view for the
 * primeng elements used throughout the application.
 */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedPrimengModule } from './shared-primeng.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { NgxSpinnerModule } from 'ngx-spinner';
import { LeafletModule } from '@bluehalo/ngx-leaflet';
import { StickyStateDirective } from './directives/sticky-state.directive';
import {
  HasRoleDirective,
  HasRolePipe,
  RoleDisabledDirective,
} from '@ind4.0/angular-common-lib';

@NgModule({
  declarations: [StickyStateDirective],
  imports: [
    CommonModule,
    SharedPrimengModule,
    FormsModule,
    ReactiveFormsModule,
    NgxSpinnerModule,
    LeafletModule,
    HasRoleDirective,
    RoleDisabledDirective,
    HasRolePipe,
  ],

  exports: [
    SharedPrimengModule,
    FormsModule,
    ReactiveFormsModule,
    NgxSpinnerModule,
    LeafletModule,
    StickyStateDirective,
  ],
})
export class SharedModule {}
